export default __webpack_public_path__ + "static/media/rotate_middle_frame.9c307195.svg";